'use client'
import { useEffect, useCallback } from 'react'
import TagManager from '@sooro-io/react-gtm-module'

import useQueryGaTagInfo from './hooks/useQueryGaTagInfo'

const GoogleAnalytic = ({
  nonce,
  smartClubAccessToken,
  smartClubId,
}: {
  nonce?: string
  smartClubAccessToken?: string
  smartClubId?: number
}) => {
  const { fetchData } = useQueryGaTagInfo({
    smartClubAccessToken,
    smartClubId,
  })

  const sendCustomerDatalayer = useCallback(async () => {
    const data = await fetchData()

    if (data) {
      setTimeout(() => {
        TagManager.dataLayer({
          dataLayer: { event: 'CustomerDataReady', ...data },
        })
      }, 0)
    }
  }, [fetchData])

  useEffect(() => {
    if (document.readyState === 'complete') {
      const timer = setTimeout(sendCustomerDatalayer, 0)
      return () => clearTimeout(timer)
    } else {
      window.addEventListener('load', sendCustomerDatalayer)
      return () => window.removeEventListener('load', sendCustomerDatalayer)
    }
  }, [sendCustomerDatalayer])

  useEffect(() => {
    if (nonce) {
      TagManager.initialize({
        gtmId: process.env.NEXT_PUBLIC_GTM_CLIENT_ID
          ? process.env.NEXT_PUBLIC_GTM_CLIENT_ID
          : '',
        nonce,
      })
    }
  }, [nonce])

  return null
}

export default GoogleAnalytic
